<script setup lang="ts">
import SlideItem from "@/components/organisms/common/HowToGuide/SlideItem.vue";
import { AbTest3113 } from "@/app/services/AbTestService";
import { sendAdjustEvent } from "@/plugins/adjust";
import { sendFirebaseCustomEvent } from "@/plugins/firebase";
import { authStore } from "@/store/auth";
import { deviceModule } from "@/store/device";
import { scrollToTop } from "@/utils/scrollUtil";
import { onMounted, computed } from "vue";
import { ref } from "vue";
// @ts-ignore
import slide01Src from "@/assets/svg/Onboarding/how-to-use-slide01.svg?webp&width=560";
// @ts-ignore
import slide02Src from "@/assets/svg/Onboarding/how-to-use-slide02.svg?webp&width=560";
// @ts-ignore
import slide03Src from "@/assets/svg/Onboarding/how-to-use-slide03.svg?webp&width=560";
// @ts-ignore
import slide04Src from "@/assets/svg/Onboarding/how-to-use-slide04.svg?webp&width=560";

const emit = defineEmits(["close"]);

const slide = ref(0);
const isBrowser = deviceModule.isBrowser;
const slides = [slide01Src, slide02Src, slide03Src, slide04Src];
const howToGuide = ref<HTMLElement | null>(null);

const closeHowToGuide = () => {
  sendAdjustEvent("CLOSE_HOW_TO_GUIDE");
  sendFirebaseCustomEvent("close_how_to_guide", {
    session_id: authStore.sessionId || "unknown"
  });
  emit("close");
};

const isAbTest3113Group = computed(() => {
  return AbTest3113.getTestGroup() !== "A";
});

onMounted(() => {
  AbTest3113.registerEvent(AbTest3113.eventTypes.entryHowToGuide);
  sendAdjustEvent("SHOW_HOW_TO_GUIDE");
  sendFirebaseCustomEvent("show_how_to_guide", {
    session_id: authStore.sessionId || "unknown"
  });
  if (isAbTest3113Group.value) {
    closeHowToGuide();
  }
});

const onClickSlide = () => {
  if (slide.value === slides.length - 1) {
    // 最後のスライドをクリックした場合
    closeHowToGuide();
    return;
  }

  slide.value++;
  if (howToGuide.value) {
    scrollToTop(howToGuide.value, { duration: 0 });
  }
};
</script>

<template>
  <div class="notch"></div>
  <div
    class="how-to-guide"
    ref="howToGuide"
    :class="{ 'is-browser': isBrowser }"
  >
    <BCarousel v-model="slide" no-wrap no-animation :interval="0">
      <BCarouselSlide v-for="(slideItemSrc, index) in slides" :key="index">
        <template #img>
          <div class="svg-container" @click="onClickSlide">
            <SlideItem :src="slideItemSrc" />
          </div>
        </template>
      </BCarouselSlide>
    </BCarousel>

    <div class="status-bar-container" data-testid="status-bar-container">
      <div
        v-for="number of slides.length"
        :key="number"
        class="status-bar"
        :class="{ 'status-bar-active': number - 1 === slide }"
        data-testid="status-bar"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.svg-container {
  position: relative;
  width: 100vw;
  height: 100dvh;

  @media screen and (max-width: 768px) {
    max-height: calc(
      100vh - env(safe-area-inset-top, 0) - env(safe-area-inset-bottom, 0)
    );
  }
}

.notch {
  height: env(safe-area-inset-top, 0);
}

.how-to-guide {
  position: relative;
  inset: 0;
  width: 100%;
  height: calc(
    100% - env(safe-area-inset-top, 0) - env(safe-area-inset-bottom, 0)
  );
  overflow: scroll;

  &.is-browser {
    background: $white;

    :deep(.carousel-inner) {
      text-align: center;
    }
  }
}

.status-bar-container {
  position: absolute;
  bottom: 10px;
  display: flex;
  justify-content: center;
  width: 100%;
}

.status-bar {
  width: 50px;
  margin: 0 5px;
  border: 3px solid $gray-04;
  border-radius: 1.5px;

  &-active {
    border: 3px solid #888;
  }
}
</style>
